import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0, // Phone
      sm: 600, // Tablet
      md: 900, // Desktop
      lg: 1200, // Large desktop
      xl: 1536, // Extra large
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: "#3f51b5", // Blue color from the UI
    },
    secondary: {
      main: "#c8ff00", // Lime green color from the "Connect Wallet" button
    },
    background: {
      default: '#ffffff', // Very light background
      paper: '#030615', // Slightly lighter background for cards
    },
    text: {
      primary: '#0a0a0a',
      secondary: '#b3b3b3',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    h6: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
      fontSize: "20px",
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: "20px",
    },
    subtitle2: {
      fontWeight: 600,
      fontSize: "16px",
    },
    body1: {
      fontSize: "16px",
    },
    body2: {
      fontSize: "0.75rem",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: "white",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 20,
          minHeight: 44,
          minWidth: 44,
        },
        containedPrimary: {
          background: "linear-gradient(45deg, #3f51b5 30%, #2196f3 90%)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(26, 26, 26, 0.8)",
          backdropFilter: "blur(10px)",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          margin: 16,
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
